import { getSubdomain } from '@/utils/http';
import { env } from '@/utils/env';

export function getBaseUrlWithoutApiAndProtocol() {
  if (process.env.NODE_ENV === 'production') {
    return `${getSubdomain()}.${env('BACKEND_API_URL')}`;
  }

  return '';
}

export function getBaseUrlWithoutApi() {
  if (process.env.NODE_ENV === 'production') {
    return `${env('PROTOCOL')}://${getBaseUrlWithoutApiAndProtocol()}`;
  }

  return '';
}

export function getBaseUrlForOwner() {
  return `${getBaseUrlWithoutApi()}/owner_portal_api/v1`;
}

export function getBaseUrlForAdminPanel() {
  return '/admin-panel/api/v1';
}

export default function getBaseUrl() {
  return `${getBaseUrlWithoutApi()}/api/v2`;
}
